import ImageCarousel from './ImageCarousel';
import { SiteContent } from '../content';

type IndoorContent = SiteContent['indoor'];

interface IndoorSectionProps {
  content: IndoorContent;
  getImageUrl: (name: string) => string;
}

export default function IndoorSection({ content, getImageUrl }: IndoorSectionProps) {
  return (
    <section id="indoor" className="section-light">
      {/* Text Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 text-center">
        <h2 className="font-display text-4xl sm:text-5xl md:text-6xl font-semibold mb-6">
          {content.title}
        </h2>
        <p className="text-lg md:text-xl text-milan-gray-dark leading-relaxed max-w-2xl mx-auto">
          {content.description}
        </p>
      </div>

      {/* Full-width Carousel */}
      <ImageCarousel
        images={content.images}
        getImageUrl={getImageUrl}
        autoplay={true}
        autoplayDelay={4000}
      />
    </section>
  );
}
